import { z } from 'zod';
export const inboundLeadSchema = z
    .object({
    email: z.string().email().optional(),
    contact_name: z.string().max(500).optional(),
    name: z.string().max(500).optional(),
    company: z.string().max(500).optional(),
    phone: z.string().max(50).optional(),
    website: z.string().max(500).optional(),
    message: z.string().max(10000).optional(),
    source_url: z.string().url().optional(),
    landing_url: z.string().url().optional(),
    utm_source: z.string().max(200).optional(),
    utm_medium: z.string().max(200).optional(),
    utm_campaign: z.string().max(200).optional(),
    utm_content: z.string().max(200).optional(),
    utm_term: z.string().max(200).optional(),
    /** Form: lead wil teruggebeld worden (L4 voice prep). */
    call_me: z.union([z.boolean(), z.string().max(20)]).optional(),
    _hp: z.string().optional(),
    /** Herken WordPress / Ploko Connect payloads. */
    source: z.enum(['wordpress', 'form']).optional(),
    wp_post_id: z.union([z.number().int(), z.string().max(40)]).optional(),
    wp_form_id: z.string().max(120).optional(),
})
    .refine((d) => d.email || d.contact_name || d.name, {
    message: 'email or name required',
});
//# sourceMappingURL=inbound.js.map